<button id="emoji-picker-trigger-btn" mat-icon-button
        #emojiPickerTrigger="matMenuTrigger" [matMenuTriggerFor]="emojiPicker"
        (menuOpened)="focusSearchField()"
        [disabled]="disabled"
        [ngClass]="{'active': emojiPickerTrigger.menuOpen}">
  <mat-icon svgIcon="insert_emoticon" class="text-[24px] mb-0"></mat-icon>
</button>

<mat-menu #emojiPicker="matMenu" yPosition="below" class="emojiPicker">
  <emoji-mart #emojiMart set="google" [color]="primaryColor" title="" emoji=""
              notFoundEmoji="mag" [i18n]="emojiPickerTranslations"
              [showSingleCategory]="true"
              (emojiSelect)="onEmojiSelection($event.emoji)"
              (click)="$event.stopPropagation(); focusSearchField()"></emoji-mart>
</mat-menu>
